import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import InstallBanner from "@/components/app/InstallBanner";
import OnlineClassCard from "@/components/app/OnlineClassCard";
import FizikalClassCard from "@/components/app/FizikalClassCard";
import { PilihanHeader, PilihanFooter } from "@/components/app/PilihanExtras";
import SuccessSection from "@/components/app/SuccessSection";
import ProsesPendaftaran from "@/components/app/ProsesPendaftaran";
import PmmHero from "@/components/app/PmmHero";
import LeadershipChart from "@/components/app/LeadershipChart";
import {
  BookOpen,
  Languages,
  MapPin,
  Video,
  QrCode,
  Wallet,
  CheckCircle2,
  Sparkles,
  Users,
  ArrowRight,
  Phone,
  Mail,
  Target,
  MonitorPlay,
  TrendingUp,
  Play,
  CircleDot,
  Calculator,
  SpellCheck,
  Trophy,
  UserCheck,
  School,
  CalendarDays,
  UserPlus,
  Layers,
  PencilLine,
  PhoneCall,
  ArrowDown,
  Star,
  X,
  MessageCircle,
  CheckCheck,
} from "lucide-react";

const PMM_LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/ksi5basw_WhatsApp%20Image%202026-08-13%20at%207.58.19%20AM.jpeg";
const HERO_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/86bgu4cw_WhatsApp%20Image%202026-08-13%20at%208.08.37%20AM.jpeg";
const PROBLEM_POSTERS = [
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/uh2bnkay_WhatsApp%20Image%202026-08-13%20at%208.26.39%20AM.jpeg",
    ms: "Masih keliru mengenal huruf ABC-Z",
    en: "Still confused recognising letters A-Z",
  },
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/y1h7xx8p_WhatsApp%20Image%202026-08-13%20at%208.28.22%20AM.jpeg",
    ms: "Boleh hafal tetapi susah membaca sendiri",
    en: "Can memorise but struggles to read alone",
  },
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/yg4sib8d_WhatsApp%20Image%202026-08-13%20at%208.33.02%20AM.jpeg",
    ms: "Membaca terlalu perlahan",
    en: "Reads too slowly",
  },
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/ko407yy1_WhatsApp%20Image%202026-08-13%20at%208.36.28%20AM.jpeg",
    ms: "Mudah hilang fokus ketika belajar",
    en: "Easily loses focus while learning",
  },
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/d23v9ao2_WhatsApp%20Image%202026-08-13%20at%208.28.57%20AM.jpeg",
    ms: "Boleh hafal tetapi susah membaca sendiri",
    en: "Can memorise but struggles to read alone",
  },
  {
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/4immflcy_WhatsApp%20Image%202026-08-13%20at%208.37.23%20AM.jpeg",
    ms: "Ibu ayah sudah ajar banyak kali tetapi masih belum lancar membaca",
    en: "Parents have taught many times but still not reading fluently",
  },
];
const IMG_PHYSICAL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/udrfn1h2_WhatsApp%20Image%202026-08-28%20at%2010.48.17%20AM.jpeg";
const FIZIKAL_GALLERY = [
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/h6zjeqga_WhatsApp%20Image%202026-08-28%20at%2010.48.17%20AM%20%281%29.jpeg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/x862s5a0_WhatsApp%20Image%202026-08-28%20at%2010.48.18%20AM.jpeg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/a275tq76_WhatsApp%20Image%202026-08-28%20at%2010.48.18%20AM%20%281%29.jpeg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/777zs41x_WhatsApp%20Image%202026-08-28%20at%2010.48.18%20AM%20%282%29.jpeg",
];
const FIZIKAL_MANAGER_POSTER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/s5bpzqj2_af7326d4-a57f-47a6-827b-8037ce32e4dd.jpeg";
const SABAH_MANAGER_POSTER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/1743vkqz_1cfdd126-e79a-431d-90a1-76b86b0ac860.jpeg";
const ONLINE_ASSET = (id, name) => `https://customer-assets-jt897jd0.emergentagent.net/job_full-restore-audit-1/artifacts/${id}_WhatsApp%20Image%202026-09-20%20at%20${name}.jpeg`;
const ONLINE_POSTERS = [
  { src: "/landing/online/poster-e.jpg", altMs: "Kelas Membaca Online - belajar dari rumah bersama tutor bertauliah", altEn: "Online Reading Class - learn from home with certified tutors" },
  { src: "/landing/online/poster-d.jpg", altMs: "Kelas Membaca Online - anak mesti lancar membaca", altEn: "Online Reading Class - every child must read fluently" },
  { src: ONLINE_ASSET("bufize94", "7.09.15%20AM"), altMs: "Anak boleh lancar membaca dalam 3-4 bulan", altEn: "Child can read fluently in 3-4 months" },
  { src: ONLINE_ASSET("nqdjmixv", "7.09.59%20AM"), altMs: "Ibubapa risau anak masih tak boleh membaca", altEn: "Parents worried child still cannot read" },
  { src: ONLINE_ASSET("mjbjv2ws", "7.10.10%20AM"), altMs: "Anak umur 4-6 masih tak kenal huruf ABC", altEn: "Children aged 4-6 still don't know ABC" },
  { src: ONLINE_ASSET("6fg61l1f", "7.09.31%20AM"), altMs: "Susah nak ajar anak membaca sebab tak fokus", altEn: "Hard to teach child to read due to lack of focus" },
];
const ONLINE_MANAGER_POSTER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/5ln00uig_WhatsApp%20Image%202026-08-28%20at%2010.34.10%20AM%20%281%29.jpeg";
const INFO_JOIN_POSTER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/mbceyvov_WhatsApp%20Image%202026-08-28%20at%2010.43.42%20AM%20%282%29.jpeg";
const WHATSAPP_TESTIMONIALS = [
  { name: "Puan Aisyah", loc: "Bdr Baru Uda JB", time: "8:45 PM", ms: "Alhamdulillah cikgu, baru 2 bulan join kelas PMM anak saya dah mula mengeja sendiri. Terima kasih banyak cikgu!", en: "Alhamdulillah, after just 2 months in PMM class my child has started spelling on her own. Thank you so much!" },
  { name: "Encik Farid", loc: "Bdr Putra Kulai", time: "9:12 PM", ms: "Anak saya dulu langsung tak minat buku. Sekarang setiap malam dia sendiri yang ajak baca. Memang berbaloi join PMM!", en: "My son had zero interest in books before. Now he asks to read every night. PMM is truly worth it!" },
  { name: "Puan Melissa", loc: "Kota Kinabalu", time: "3:20 PM", ms: "Kelas online sangat teratur, cikgu sabar melayan anak saya. 3 bulan dah lancar baca ayat pendek. Syukur sangat.", en: "The online class is well organised and the teacher is so patient. In 3 months my child reads short sentences fluently." },
  { name: "Puan Siti", loc: "Batu Pahat", time: "7:58 PM", ms: "Cikgu update progress anak setiap kelas. Saya boleh nampak perkembangan dia minggu demi minggu. Highly recommended!", en: "The teacher updates my child's progress after every class. I can see improvement week by week. Highly recommended!" },
  { name: "Encik Hafiz", loc: "Tawau Sabah", time: "10:05 AM", ms: "Teknik mengeja PMM ni memang berkesan. Anak saya baru 5 tahun dah kenal semua suku kata. Terima kasih cikgu!", en: "The PMM spelling technique really works. My 5-year-old already knows all the syllables. Thank you teacher!" },
  { name: "Puan Nurul", loc: "Skudai Johor", time: "8:30 PM", ms: "Dulu risau anak masuk Darjah 1 tak boleh baca. Lepas join PMM, sekarang dia antara paling laju membaca dalam kelas!", en: "I was worried my child would enter Year 1 unable to read. After PMM, she is now among the fastest readers in class!" },
];
const WA_MSG = encodeURIComponent("Assalamualaikum Cikgu, saya berminat nak tahu info detail kelas, yuran & jadual Kelas Program Membaca PMM.");
const MANAGERS = {
  fizikal: { name: "Cikgu Shafie", phoneDisplay: "016-7202689", wa: `https://wa.me/60167202689?text=${WA_MSG}` },
  sabah: { name: "Cikgu Imran", phoneDisplay: "013-8997675", wa: `https://wa.me/60138997675?text=${WA_MSG}` },
  online: { name: "Cikgu Zarith", phoneDisplay: "017-8730024", wa: `https://wa.me/60178730024?text=${WA_MSG}` },
};
const FIZIKAL_BRANCH_POSTERS = [
  { loc: "Bdr Baru Uda JB", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/thaddsd2_WhatsApp%20Image%202026-08-28%20at%2010.32.38%20AM%20%281%29.jpeg" },
  { loc: "Bdr Putra Kulai", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/0sv0l6cv_WhatsApp%20Image%202026-08-28%20at%2010.32.39%20AM.jpeg" },
  { loc: "Batu Pahat Johor", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/dbg3je4v_WhatsApp%20Image%202026-08-28%20at%2010.32.39%20AM%20%281%29.jpeg" },
  { loc: "Tawau Sabah", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/z70so9i2_WhatsApp%20Image%202026-08-28%20at%2010.32.39%20AM%20%282%29.jpeg" },
  { loc: "Sulaman KK", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/motpif3d_WhatsApp%20Image%202026-08-28%20at%2010.32.40%20AM.jpeg" },
  { loc: "Cyber Square KK", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_db-audit-recovery/artifacts/gvyf0d38_WhatsApp%20Image%202026-08-28%20at%2010.32.39%20AM%20%283%29.jpeg" },
];

export default function Landing() {
  const { lang, setLang } = useI18n();
  const ms = lang === "ms";
  const [cms, setCms] = useState({});
  const [lightbox, setLightbox] = useState(null);
  // Keep the shorter Kelas Fizikal card in view while the longer Online card scrolls (desktop only)
  const fizikalRef = useRef(null);
  const [fizikalTop, setFizikalTop] = useState(80);
  useEffect(() => {
    const el = fizikalRef.current;
    if (!el) return undefined;
    const update = () => setFizikalTop(Math.min(80, window.innerHeight - el.offsetHeight - 24));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    return () => { ro.disconnect(); window.removeEventListener("resize", update); };
  }, []);

  useEffect(() => {
    api.get("/content/landing").then((r) => setCms(r.data.content || {})).catch(() => {});
  }, []);

  // helper: CMS value if set, else bilingual default
  const c = (key, msDefault, enDefault) => cms[key] || (ms ? msDefault : enDefault ?? msDefault);

  const features = [
    {
      icon: QrCode,
      title: ms ? "Kehadiran QR & Manual" : "QR & Manual Attendance",
      desc: ms
        ? "Ibu bapa imbas QR di pusat, cikgu tanda kehadiran — semua direkod dengan kemas."
        : "Parents scan the wall QR, teachers mark attendance — all neatly recorded.",
    },
    {
      icon: Video,
      title: ms ? "Video Perkembangan Anak" : "Child Progress Videos",
      desc: ms
        ? "Cikgu kongsi video latihan membaca dan gambar buku latihan anak anda setiap bulan."
        : "Teachers share reading practice videos and workbook photos of your child every month.",
    },
    {
      icon: Wallet,
      title: ms ? "Yuran & Resit Digital" : "Digital Fees & Receipts",
      desc: ms
        ? "Bayar yuran secara online (kad / FPX) dan muat turun resit rasmi bila-bila masa."
        : "Pay fees online (card / FPX) and download official receipts anytime.",
    },
    {
      icon: Users,
      title: ms ? "Portal Ibu Bapa" : "Parent Portal",
      desc: ms
        ? "Jadual kelas, laporan kehadiran dan perkembangan anak — semua dalam satu aplikasi."
        : "Class timetable, attendance reports and child progress — all in one app.",
    },
  ];

  return (
    <div className="min-h-screen bg-background grain-bg">
      <InstallBanner />
      {/* Header */}
      <header className="sticky top-0 z-30 bg-gradient-to-r from-blue-950 via-blue-900 to-blue-950 shadow-lg shadow-blue-950/30 backdrop-blur">
        <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-3 py-3 sm:px-6">
          <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
            <div className="shrink-0 rounded-2xl bg-gradient-to-br from-yellow-300 via-yellow-500 to-orange-500 p-0.5 shadow-lg shadow-yellow-500/20">
              <img src={PMM_LOGO} alt="Logo PMM" className="h-9 w-9 rounded-[0.9rem] object-cover sm:h-10 sm:w-10" data-testid="landing-header-logo" />
            </div>
            <div className="min-w-0 leading-tight">
              <div className="font-display text-[13px] font-extrabold uppercase tracking-tight text-white sm:text-lg">Kelas Program Membaca PMM</div>
              <div className="flex items-center gap-1.5 text-[9px] font-bold uppercase tracking-widest text-yellow-400 sm:text-[11px]">
                <Star className="h-3 w-3 shrink-0 fill-yellow-400 text-yellow-400" />
                <span className="truncate">{ms ? "Mesti Lancar Baca — Sejak 2007" : "Must Read Fluently — Since 2007"}</span>
              </div>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLang(ms ? "en" : "ms")}
              className="gap-2 rounded-full border border-white/20 px-2.5 text-blue-100 hover:bg-white/10 hover:text-white sm:px-3"
              data-testid="landing-lang-toggle"
            >
              <Languages className="h-4 w-4" />
              <span className="hidden sm:inline">{ms ? "English" : "Bahasa Malaysia"}</span>
            </Button>
            <Link to="/login">
              <Button className="rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-4 font-display text-xs font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-500/30 transition-transform duration-300 hover:scale-105 sm:px-6 sm:text-sm" data-testid="landing-login-btn">
                {ms ? "Log masuk" : "Sign in"}
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero — dibina semula dari poster "Program Membaca PMM" */}
      <PmmHero ms={ms} cms={cms} logo={PMM_LOGO} />

      {/* Masalah Ibu Bapa */}
      <section className="relative overflow-hidden bg-gradient-to-b from-blue-600 via-blue-500 to-blue-600" data-testid="landing-problems-section">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-red-600" data-testid="problems-title-red">{ms ? "Masalah" : "Problems"}</span>{" "}
              <span className="text-white [text-shadow:0_3px_0_rgba(13,37,102,0.55)]" data-testid="problems-title-black">{ms ? "Yang Ibu Bapa Sedang Hadapi" : "Parents Are Facing"}</span>
            </h2>
            <p className="mt-3 font-semibold uppercase tracking-wide text-white" data-testid="problems-subtitle">
              {ms
                ? "Kenali masalah membaca anak anda — Program Membaca PMM ada penyelesaiannya."
                : "Recognise your child's reading struggles — the PMM Reading Program has the solution."}
            </p>
          </div>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {PROBLEM_POSTERS.map((p, i) => (
              <div key={i} className="overflow-hidden rounded-3xl border-2 border-white/70 shadow-xl shadow-blue-950/30 transition-transform duration-300 hover:-translate-y-1 hover:border-yellow-300 hover:shadow-2xl" data-testid={`landing-problem-card-${i + 1}`}>
                <img src={p.img} alt={ms ? p.ms : p.en} className="h-auto w-full" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Program Pilihan Kelas Membaca */}
      <section className="relative overflow-x-clip" data-testid="landing-pilihan-section">
        <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-10 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <PilihanHeader ms={ms} setLightbox={setLightbox} />

          <div className="relative mt-16 grid gap-10 md:grid-cols-2 md:items-start md:gap-8">
            {/* ATAU badge */}
            <div className="pmm-atau absolute left-1/2 top-[22rem] z-10 hidden h-20 w-20 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border-4 border-white bg-blue-900 shadow-2xl md:grid" data-testid="pilihan-atau-badge">
              <span className="font-display text-lg font-extrabold uppercase text-white">{ms ? "Atau" : "Or"}</span>
            </div>

            {/* Kelas Fizikal */}
            <FizikalClassCard
              ms={ms}
              cms={cms}
              setLightbox={setLightbox}
              cardRef={fizikalRef}
              top={fizikalTop}
              managers={MANAGERS}
              managerPoster={FIZIKAL_MANAGER_POSTER}
              sabahPoster={SABAH_MANAGER_POSTER}
              gallery={FIZIKAL_GALLERY}
              mainImg={IMG_PHYSICAL}
              branches={FIZIKAL_BRANCH_POSTERS}
            />

            {/* mobile ATAU */}
            <div className="mx-auto -my-4 grid h-16 w-16 place-items-center rounded-full border-4 border-white bg-blue-900 shadow-xl md:hidden">
              <span className="font-display text-base font-extrabold uppercase text-white">{ms ? "Atau" : "Or"}</span>
            </div>

            {/* Kelas Online */}
            <OnlineClassCard
              ms={ms}
              cms={cms}
              setLightbox={setLightbox}
              manager={MANAGERS.online}
              managerPoster={ONLINE_MANAGER_POSTER}
              posters={ONLINE_POSTERS}
            />
          </div>
          <PilihanFooter ms={ms} />
        </div>
      </section>

      {/* 20,000 Pelajar Lancar Membaca */}
      <SuccessSection ms={ms} setLightbox={setLightbox} />

      {/* Jangan Risau + Apa Itu PMM */}
      <section className="relative overflow-hidden bg-gradient-to-b from-blue-600 via-blue-500 to-blue-600" data-testid="landing-apaitu-section">
        <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-orange-500/15 blur-3xl" />
        <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-blue-500/15 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="pmm-pop font-display text-4xl font-extrabold uppercase tracking-tight text-red-600 sm:text-6xl" data-testid="jangan-risau-title">
              {ms ? "Jangan Risau!" : "Don't Worry!"}
            </h2>
            <p className="mt-5 text-xl font-semibold leading-relaxed text-white sm:text-2xl" data-testid="jangan-risau-text">
              {ms ? (
                <>Anak bukan tak pandai — mereka mungkin perlukan <span className="font-bold text-white">teknik dan latihan yang sesuai dengan tahap mereka.</span></>
              ) : (
                <>Your child isn't slow — they may just need <span className="font-bold text-white">the right technique and practice suited to their level.</span></>
              )}
            </p>
          </div>

          <div className="mt-14 grid items-center gap-10 md:grid-cols-2">
            <div className="pmm-pop rounded-[2rem] border-2 border-white bg-white p-8 shadow-2xl shadow-blue-950/30 transition-transform duration-300 hover:-translate-y-1 sm:p-10" style={{ animationDelay: "0.15s" }} data-testid="apaitu-card">
              <span className="inline-block rounded-full bg-orange-500 px-6 py-2 font-display text-base font-extrabold sm:text-lg uppercase tracking-widest text-white shadow-md">
                {ms ? "Apa Itu" : "What Is"}
              </span>
              <h3 className="mt-4 font-display text-4xl font-extrabold uppercase leading-tight text-blue-700 sm:text-5xl">
                {ms ? "Program Membaca PMM?" : "The PMM Reading Program?"}
              </h3>
              <p className="mt-5 text-lg leading-relaxed text-black sm:text-xl" data-testid="apaitu-desc">
                {ms ? (
                  <>Program Membaca PMM ialah program pembelajaran membaca secara berperingkat yang menggunakan <span className="font-bold text-black">Teknik Mengeja PMM</span>, <span className="font-bold text-black">Latihan Step-by-Step</span> dan <span className="font-bold text-black">Modul Eksklusif PMM</span> yang disusun mengikut tahap penguasaan anak.</>
                ) : (
                  <>The PMM Reading Program is a step-by-step reading programme using the <span className="font-bold text-black">PMM Spelling Technique</span>, <span className="font-bold text-black">Step-by-Step Practice</span> and the <span className="font-bold text-black">Exclusive PMM Modules</span> arranged according to each child's mastery level.</>
                )}
              </p>
            </div>

            <ul className="space-y-3" data-testid="apaitu-highlights">
              {[
                { ms: "PMM Sejak Tahun 2007", en: "PMM Since 2007" },
                { ms: "20,000+ Pelajar Telah Lancar Membaca", en: "20,000+ Students Now Read Fluently" },
                { ms: "Buku Modul PMM Disediakan — Latihan Praktikal", en: "PMM Module Books Provided — Practical Exercises" },
                { ms: "Kelas Fizikal & Kelas Online", en: "Physical & Online Classes" },
                { ms: "48 Langkah Pembelajaran", en: "48 Learning Steps" },
                { ms: "Video Pembelajaran / Aplikasi APPS PMM", en: "Learning Videos / PMM APPS Application" },
                { ms: "Modul Eksklusif Yang Sangat Praktikal Dan 100% Berkesan", en: "Exclusive Modules — Highly Practical & 100% Effective" },
              ].map((h, i) => (
                <li key={i} className="pmm-pop group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 px-5 py-3.5 backdrop-blur transition-all duration-300 hover:translate-x-2 hover:border-orange-400/50 hover:bg-white/10" style={{ animationDelay: `${0.2 + i * 0.1}s` }}>
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-orange-500 text-white shadow-md transition-transform duration-300 group-hover:scale-110">
                    <Play className="h-4 w-4 fill-current" />
                  </span>
                  <span className="font-semibold text-white">{ms ? h.ms : h.en}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Modul Pembelajaran PMM */}
      <section className="relative overflow-hidden" data-testid="landing-modul-section">
        <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -left-24 bottom-10 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-orange-500/10 px-4 py-1.5 text-sm font-semibold text-orange-600">
              <BookOpen className="h-4 w-4" />
              {ms ? "Modul Eksklusif PMM" : "Exclusive PMM Modules"}
            </span>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-blue-800">{ms ? "Modul Pembelajaran" : "Learning Modules"}</span>{" "}
              <span className="text-orange-500">PMM</span>
            </h2>
          </div>

          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {[
              {
                num: 1,
                color: "orange",
                items: ms
                  ? ["Kenal huruf ABC-Z tanpa hafal", "Belajar bunyi huruf", "Teknik Mengeja", "Faham bunyi suku kata", "Membina perkataan mudah"]
                  : ["Recognise letters A-Z without memorising", "Learn letter sounds", "Spelling Technique", "Understand syllable sounds", "Build simple words"],
              },
              {
                num: 2,
                color: "blue",
                items: ms
                  ? ["Membaca perkataan panjang", "Ayat mudah — pemahaman / karangan", "Kelancaran membaca", "Latihan membaca", "Peningkatan keyakinan diri", "Kecemerlangan pembelajaran di sekolah bermula dengan kelancaran membaca"]
                  : ["Reading longer words", "Simple sentences — comprehension / writing", "Reading fluency", "Reading practice", "Boosted self-confidence", "School excellence begins with reading fluency"],
              },
            ].map((t) => (
              <div
                key={t.num}
                className={`pmm-pop ${t.num === 1 ? "pmm-float" : "pmm-float-delayed"} rounded-[2rem] border-4 bg-white p-8 shadow-2xl transition-shadow duration-300 ${
                  t.color === "orange"
                    ? "border-orange-500 shadow-orange-500/20 hover:shadow-orange-500/40"
                    : "border-blue-800 shadow-blue-800/20 hover:shadow-blue-800/40"
                }`}
                style={{ animationDelay: `${t.num * 0.15}s` }}
                data-testid={`modul-card-tahap-${t.num}`}
              >
                <div className="flex items-center gap-4">
                  <div className={`grid h-16 w-16 shrink-0 place-items-center rounded-2xl font-display text-3xl font-extrabold text-white shadow-lg ${t.color === "orange" ? "bg-orange-500" : "bg-blue-800"}`}>
                    {t.num}
                  </div>
                  <h3 className={`font-display text-4xl font-extrabold uppercase tracking-tight ${t.color === "orange" ? "text-orange-500" : "text-blue-800"}`}>
                    {ms ? "Tahap" : "Level"} {t.num}
                  </h3>
                </div>
                <ul className="mt-6 space-y-3">
                  {t.items.map((it, i) => (
                    <li key={i} className="flex items-start gap-3 text-base font-semibold text-blue-950">
                      <CircleDot className={`mt-0.5 h-5 w-5 shrink-0 ${t.color === "orange" ? "text-orange-500" : "text-blue-700"}`} />
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subjek Yang Ditawarkan */}
      <section className="relative overflow-hidden bg-gradient-to-br from-blue-950 via-blue-900 to-orange-600" data-testid="landing-subjek-section">
        <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-orange-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-orange-500/25 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">
              {ms ? "Subjek Yang" : "Subjects"}{" "}
              <span className="text-orange-400">{ms ? "Ditawarkan" : "Offered"}</span>
            </h2>
          </div>

          <div className="mt-14 grid gap-8 lg:grid-cols-2">
            {/* Cinematic Card 1: Subjek */}
            <div className="pmm-pop pmm-cinematic relative flex flex-col justify-center rounded-[2rem] border border-white/15 bg-white/5 p-6 shadow-2xl backdrop-blur-xl transition-transform duration-500 hover:scale-[1.02] hover:-rotate-1 sm:p-8" style={{ animationDelay: "0.1s" }} data-testid="subjek-card">
              <div className="space-y-6">
                {[
                  {
                    icon: BookOpen,
                    grad: "from-orange-600 to-orange-400",
                    title: ms ? "Bahasa Melayu" : "Malay Language",
                    desc: ms ? "Kelancaran membaca, latihan pemahaman & karangan" : "Reading fluency, comprehension exercises & essay writing",
                  },
                  {
                    icon: Calculator,
                    grad: "from-navy-800 to-navy-600",
                    title: ms ? "Matematik" : "Mathematics",
                    desc: ms
                      ? "Asas tambah, tolak, darab dan bahagi, memahami soalan matematik dalam bentuk perkataan"
                      : "Basic addition, subtraction, multiplication & division, understanding word problems",
                  },
                  {
                    icon: SpellCheck,
                    grad: "from-orange-600 to-orange-400",
                    title: ms ? "Bahasa Inggeris" : "English Language",
                    desc: ms ? "Asas ejaan, maksud perkataan, membina ayat dalam Bahasa Inggeris" : "Basic spelling, word meanings, building sentences in English",
                  },
                ].map((s, i) => (
                  <div key={s.title} className={`pmm-pop group flex items-start gap-4 rounded-2xl bg-gradient-to-r ${s.grad} p-5 shadow-lg transition-transform duration-300 hover:translate-x-2`} style={{ animationDelay: `${0.2 + i * 0.15}s` }} data-testid={`subjek-item-${i + 1}`}>
                    <div className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl border-2 border-yellow-300/70 bg-white text-blue-900 shadow-md transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                      <s.icon className="h-7 w-7" />
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <CheckCircle2 className="h-5 w-5 text-yellow-300" />
                        <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-yellow-300">{s.title}</h3>
                      </div>
                      <p className="mt-1 text-sm font-medium leading-relaxed text-white/90">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Cinematic Card 2: Kuasai 3 Asas */}
            <div className="pmm-pop pmm-cinematic relative flex flex-col justify-between rounded-[2rem] border border-white/15 bg-white/5 p-6 shadow-2xl backdrop-blur-xl transition-transform duration-500 hover:scale-[1.02] hover:rotate-1 sm:p-8" style={{ animationDelay: "0.25s" }} data-testid="kuasai-card">
              <div className="text-center">
                <p className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                  {ms ? "PMM Bantu Anak" : "PMM Helps Your Child"}
                </p>
                <h3 className="mt-1 font-display text-6xl font-extrabold uppercase tracking-tight text-transparent sm:text-7xl" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                  {ms ? "Kuasai" : "Master"}
                </h3>
                <div className="mx-auto mt-2 inline-block -rotate-1 rounded-xl bg-orange-500 px-6 py-2 shadow-lg">
                  <span className="font-display text-xl font-extrabold uppercase text-white sm:text-2xl">
                    {ms ? "3 Asas Utama!" : "3 Core Foundations!"}
                  </span>
                </div>
              </div>
              <div className="mt-8 grid grid-cols-3 gap-3">
                {[
                  { icon: Target, ms: "Fokus & Berkesan", en: "Focused & Effective" },
                  { icon: TrendingUp, ms: "Sistem Terbukti & Teruji", en: "Proven & Tested System" },
                  { icon: Trophy, ms: "Hasil Pasti Memuaskan", en: "Guaranteed Satisfying Results" },
                ].map((b, i) => (
                  <div key={b.ms} className="pmm-pop flex flex-col items-center gap-3 rounded-2xl border border-yellow-400/30 bg-blue-950/60 p-4 text-center transition-all duration-300 hover:-translate-y-2 hover:border-yellow-400/70 hover:bg-blue-950" style={{ animationDelay: `${0.35 + i * 0.15}s` }}>
                    <div className="grid h-14 w-14 place-items-center rounded-full bg-gradient-to-br from-yellow-300 to-orange-500 text-blue-950 shadow-lg">
                      <b.icon className="h-7 w-7" />
                    </div>
                    <span className="text-xs font-bold uppercase leading-tight text-white sm:text-sm">{ms ? b.ms : b.en}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8 space-y-3">
                {[
                  { icon: BookOpen, t: ms ? "Teknik Mengeja" : "Spelling Technique", d: ms ? "Berpandukan 48 langkah" : "Guided by 48 steps" },
                  { icon: UserCheck, t: ms ? "Pengajar Terlatih" : "Trained Teachers", d: ms ? "Berpengalaman & profesional" : "Experienced & professional" },
                  { icon: Users, t: ms ? "Sistem Pembelajaran" : "Learning System", d: ms ? "Modul praktikal & interaktif" : "Practical & interactive modules" },
                ].map((f) => (
                  <div key={f.t} className="flex items-center gap-4 rounded-2xl bg-white/10 px-5 py-3 backdrop-blur transition-colors duration-300 hover:bg-white/20">
                    <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-yellow-400 text-blue-950">
                      <f.icon className="h-5 w-5" />
                    </div>
                    <div>
                      <div className="font-display text-sm font-extrabold uppercase text-white">{f.t}</div>
                      <div className="text-xs text-blue-100">{f.d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kenapa Ibu Bapa Pilih PMM */}
      <section className="relative overflow-hidden" data-testid="landing-kenapa-section">
        <div className="pointer-events-none absolute -right-24 top-16 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -left-24 bottom-16 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-blue-800">{ms ? "Kenapa Ibu Bapa" : "Why Parents"}</span>{" "}
              <span className="text-orange-500">{ms ? "Pilih PMM?" : "Choose PMM?"}</span>
            </h2>
          </div>

          <div className="mt-12 grid items-center gap-12 lg:grid-cols-2">
            {/* Checklist */}
            <ul className="space-y-3" data-testid="kenapa-checklist">
              {[
                { ms: "Teknik belajar step-by-step", en: "Step-by-step learning technique" },
                { ms: "Sesuai untuk anak umur 4-9 tahun", en: "Suitable for children aged 4-9" },
                { ms: "Modul buku mengikut tahap anak", en: "Module books based on your child's level" },
                { ms: "Kelas secara fizikal & online", en: "Physical & online classes" },
                { ms: "Tutor membimbing anak secara langsung", en: "Tutors guide your child directly" },
                { ms: "Latihan berterusan", en: "Continuous practice" },
                { ms: "Ibu bapa boleh pantau perkembangan anak", en: "Parents can track their child's progress" },
                { ms: "Anak belajar dalam suasana yang lebih menyeronokkan, minat dan berkeyakinan tinggi", en: "Children learn in a fun environment with high interest and confidence" },
              ].map((item, i) => (
                <li key={i} className="pmm-pop group flex items-start gap-4 rounded-2xl border border-blue-100 bg-white px-5 py-3.5 shadow-sm transition-all duration-300 hover:translate-x-2 hover:border-orange-300 hover:shadow-lg" style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-gradient-to-br from-orange-500 to-orange-400 text-white shadow-md transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12">
                    <CheckCircle2 className="h-5 w-5" />
                  </span>
                  <span className="pt-0.5 font-semibold text-blue-950">{ms ? item.ms : item.en}</span>
                </li>
              ))}
            </ul>

            {/* Gambar cinematic */}
            <div className="relative mx-auto w-full max-w-lg" data-testid="kenapa-images">
              <div className="pointer-events-none absolute -inset-8 rounded-[3rem] bg-gradient-to-br from-orange-500/15 via-transparent to-blue-700/15 blur-2xl" />
              <div className="pmm-pop pmm-float pmm-cinematic relative rotate-2 overflow-hidden rounded-[2rem] border-4 border-white shadow-2xl shadow-blue-900/30 transition-transform duration-500 hover:rotate-0 hover:scale-[1.03]" style={{ animationDelay: "0.2s" }}>
                <img
                  src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/9r7zupcy_WhatsApp%20Image%202026-08-13%20at%209.10.34%20AM.jpeg"
                  alt={ms ? "Kanak-kanak Program Membaca PMM" : "PMM Reading Program children"}
                  className="h-72 w-full object-cover object-bottom sm:h-80"
                  loading="lazy"
                />
              </div>
              <div className="pmm-pop pmm-float-delayed pmm-cinematic relative z-10 -mt-10 ml-auto w-4/5 -rotate-2 overflow-hidden rounded-[2rem] border-4 border-white shadow-2xl shadow-orange-500/30 transition-transform duration-500 hover:rotate-0 hover:scale-[1.03]" style={{ animationDelay: "0.4s" }}>
                <img
                  src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/y56ur20s_WhatsApp%20Image%202026-08-13%20at%209.11.12%20AM.jpeg"
                  alt={ms ? "Anak belajar dengan modul PMM" : "Child learning with PMM module"}
                  className="h-auto w-full"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-14 bg-gradient-to-t from-orange-600/80 to-transparent" />
                <div className="absolute bottom-2.5 left-0 right-0 text-center font-display text-xs font-extrabold uppercase tracking-wide text-white sm:text-sm">
                  {ms ? "Modul Eksklusif PMM" : "Exclusive PMM Module"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Flip Cards: Fizikal vs Online */}
      <section className="border-y border-border/60 bg-muted/30" data-testid="landing-flip-section">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-blue-800">{ms ? "Pilih Kelas" : "Pick The Class"}</span>{" "}
              <span className="text-orange-500">{ms ? "Anak Anda" : "For Your Child"}</span>
            </h2>
          </div>

          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {/* Flip Card Fizikal */}
            <div className="pmm-pop pmm-flip h-[420px] cursor-pointer" style={{ animationDelay: "0.1s" }} onClick={(e) => e.currentTarget.classList.toggle("flipped")} data-testid="flip-card-fizikal">
              <div className="pmm-flip-inner">
                <div className="pmm-flip-face pmm-cinematic relative flex flex-col items-center justify-center rounded-[2rem] bg-gradient-to-br from-orange-600 via-orange-500 to-amber-500 p-8 text-center shadow-2xl shadow-orange-500/30">
                  <div className="pmm-float grid h-24 w-24 place-items-center rounded-full border-4 border-yellow-200/70 bg-white text-orange-600 shadow-xl">
                    <School className="h-12 w-12" />
                  </div>
                  <h3 className="mt-6 font-display text-4xl font-extrabold uppercase text-white">{ms ? "Kelas Fizikal" : "Physical Class"}</h3>
                  <p className="mt-3 max-w-xs font-semibold text-orange-50">
                    {ms ? "Sesuai untuk ibu bapa yang mahu anak belajar secara bersemuka" : "For parents who want their child to learn face-to-face"}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white backdrop-blur">
                    <ArrowRight className="h-3.5 w-3.5" /> {ms ? "Lihat Kelebihan" : "See Benefits"}
                  </span>
                </div>
                <div className="pmm-flip-face pmm-flip-back flex flex-col justify-center rounded-[2rem] border-4 border-orange-500 bg-white p-8 shadow-2xl">
                  <h3 className="text-center font-display text-2xl font-extrabold uppercase text-orange-500">{ms ? "Kelas Fizikal" : "Physical Class"}</h3>
                  <ul className="mt-6 space-y-3.5">
                    {(ms
                      ? ["Kelas bersama Tutor/Cikgu", "Interaksi secara langsung", "Aktiviti pembelajaran", "Latihan membaca", "Pemantauan Tutor/Cikgu"]
                      : ["Classes with a Tutor/Teacher", "Direct interaction", "Learning activities", "Reading practice", "Tutor/Teacher monitoring"]
                    ).map((item) => (
                      <li key={item} className="flex items-center gap-3 font-semibold text-blue-950">
                        <CheckCircle2 className="h-5 w-5 shrink-0 text-orange-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Flip Card Online */}
            <div className="pmm-pop pmm-flip h-[420px] cursor-pointer" style={{ animationDelay: "0.25s" }} onClick={(e) => e.currentTarget.classList.toggle("flipped")} data-testid="flip-card-online">
              <div className="pmm-flip-inner">
                <div className="pmm-flip-face pmm-cinematic relative flex flex-col items-center justify-center rounded-[2rem] bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 p-8 text-center shadow-2xl shadow-blue-800/30">
                  <div className="pmm-float-delayed grid h-24 w-24 place-items-center rounded-full border-4 border-yellow-200/70 bg-white text-blue-800 shadow-xl">
                    <MonitorPlay className="h-12 w-12" />
                  </div>
                  <h3 className="mt-6 font-display text-4xl font-extrabold uppercase text-white">{ms ? "Kelas Online PMM" : "PMM Online Class"}</h3>
                  <p className="mt-3 max-w-xs font-semibold text-blue-100">
                    {ms ? "Belajar dari rumah, di mana-mana sahaja anda berada" : "Learn from home, wherever you are"}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white backdrop-blur">
                    <ArrowRight className="h-3.5 w-3.5" /> {ms ? "Lihat Kelebihan" : "See Benefits"}
                  </span>
                </div>
                <div className="pmm-flip-face pmm-flip-back flex flex-col justify-center rounded-[2rem] border-4 border-blue-800 bg-white p-8 shadow-2xl">
                  <h3 className="text-center font-display text-2xl font-extrabold uppercase text-blue-800">{ms ? "Kelas Online PMM" : "PMM Online Class"}</h3>
                  <ul className="mt-6 space-y-3.5">
                    {(ms
                      ? ["Kelas secara online melalui Zoom ATAU Google Meet", "Tutor/Cikgu mengajar secara langsung", "Tidak perlu keluar rumah", "Sesuai untuk ibu bapa di luar kawasan PMM", "Boleh belajar di mana-mana"]
                      : ["Online classes via Zoom OR Google Meet", "Tutor/Teacher teaches live", "No need to leave home", "Perfect for parents outside PMM areas", "Learn from anywhere"]
                    ).map((item) => (
                      <li key={item} className="flex items-center gap-3 font-semibold text-blue-950">
                        <CheckCircle2 className="h-5 w-5 shrink-0 text-blue-700" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link to="/register">
              <Button size="lg" className="pmm-atau h-14 gap-2 rounded-full bg-gradient-to-r from-blue-800 to-blue-600 px-10 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-2xl shadow-blue-800/40 transition-transform duration-300 hover:scale-105 sm:text-lg" data-testid="cta-nak-kelas-online">
                <MonitorPlay className="h-5 w-5" />
                {ms ? "Saya Nak Kelas Online" : "I Want The Online Class"}
                <ArrowRight className="h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Bagaimana Kelas PMM Dijalankan */}
      <section className="relative overflow-hidden" data-testid="landing-langkah-section">
        <div className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-16 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-blue-800">{ms ? "Bagaimana Kelas PMM" : "How PMM Classes"}</span>{" "}
              <span className="text-orange-500">{ms ? "Dijalankan" : "Are Run"}</span>
            </h2>
          </div>

          <div className="relative mt-14 grid gap-10 lg:grid-cols-5 lg:gap-6">
            {[
              { icon: UserPlus, ms: "Daftar Kelas PMM", en: "Register for a PMM class" },
              { icon: Layers, ms: "Anak ditempatkan mengikut Tahap", en: "Your child is placed by Level" },
              { icon: BookOpen, ms: "Tutor/Cikgu mengajar menggunakan Modul Latihan Eksklusif PMM", en: "Tutors teach using the Exclusive PMM Practice Modules" },
              { icon: PencilLine, ms: "Anak membuat latihan bacaan secara praktikal 100% berkesan", en: "Your child does practical reading exercises — 100% effective" },
              { icon: PhoneCall, ms: "Ibu bapa memantau perkembangan anak, boleh hubungi ADMIN CAWANGAN PMM masing-masing", en: "Parents track progress and can contact their PMM BRANCH ADMIN anytime" },
            ].map((s, i) => (
              <div key={i} className="relative" data-testid={`langkah-step-${i + 1}`}>
                <div className={`pmm-pop ${i % 2 === 0 ? "pmm-float" : "pmm-float-delayed"} flex h-full flex-col items-center rounded-[1.75rem] border-2 bg-white p-6 text-center shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${i % 2 === 0 ? "border-orange-400 shadow-orange-500/15" : "border-blue-700 shadow-blue-800/15"}`} style={{ animationDelay: `${0.15 + i * 0.18}s` }}>
                  <div className={`grid h-16 w-16 place-items-center rounded-full text-white shadow-lg ${i % 2 === 0 ? "bg-gradient-to-br from-orange-600 to-orange-400" : "bg-gradient-to-br from-blue-900 to-blue-600"}`}>
                    <s.icon className="h-8 w-8" />
                  </div>
                  <span className={`mt-4 rounded-full px-4 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-white ${i % 2 === 0 ? "bg-orange-500" : "bg-blue-800"}`}>
                    {ms ? "Langkah" : "Step"} {i + 1}
                  </span>
                  <p className="mt-3 text-sm font-semibold leading-relaxed text-blue-950">{ms ? s.ms : s.en}</p>
                </div>
                {i < 4 && (
                  <>
                    <div className="pmm-arrow-x absolute -right-6 top-1/2 z-10 hidden -translate-y-1/2 lg:block">
                      <ArrowRight className={`h-7 w-7 ${i % 2 === 0 ? "text-orange-500" : "text-blue-700"}`} />
                    </div>
                    <div className="pmm-arrow-y absolute -bottom-9 left-1/2 z-10 -translate-x-1/2 lg:hidden">
                      <ArrowDown className={`h-7 w-7 ${i % 2 === 0 ? "text-orange-500" : "text-blue-700"}`} />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimoni Pelajar Cemerlang */}
      <section className="relative overflow-hidden bg-gradient-to-b from-blue-950 via-[#12318a] to-blue-950" data-testid="landing-testimoni-section">
        <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-yellow-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-blue-500/15 blur-3xl" />
        <div className="relative py-20">
          <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
            <div className="flex items-center justify-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="pmm-pop h-6 w-6 fill-yellow-400 text-yellow-400" style={{ animationDelay: `${i * 0.12}s` }} />
              ))}
            </div>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                {ms ? "Testimoni" : "Testimonials"}
              </span>{" "}
              <span className="text-white">{ms ? "Pelajar Cemerlang PMM" : "PMM Star Students"}</span>
            </h2>
            <div className="mx-auto mt-4 h-1 w-40 rounded-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
            <p className="mt-4 font-semibold uppercase tracking-wide text-blue-200">
              {ms ? "Syabas & tahniah kepada semua ibu bapa & anak yang berjaya!" : "Congratulations to every parent & child who succeeded!"}
            </p>
          </div>

          <div className="mt-12 overflow-hidden" data-testid="testimoni-marquee">
            <div className="pmm-marquee gap-6 px-3">
              {[...Array(2)].flatMap((_, dup) =>
                [
                  "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/k89i6y67_WhatsApp%20Image%202026-08-13%20at%2011.27.23%20AM.jpeg",
                  "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/55s4clxz_WhatsApp%20Image%202026-08-13%20at%2011.27.23%20AM%20%281%29.jpeg",
                  "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/wyehtxpj_WhatsApp%20Image%202026-08-13%20at%2011.27.23%20AM%20%282%29.jpeg",
                  "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/dzbjnn0d_WhatsApp%20Image%202026-08-13%20at%2011.27.24%20AM.jpeg",
                  "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/b1xa813b_WhatsApp%20Image%202026-08-13%20at%2011.27.24%20AM%20%281%29.jpeg",
                ].map((src, i) => (
                  <div key={`${dup}-${i}`} className="pmm-cinematic relative w-64 shrink-0 overflow-hidden rounded-3xl border-2 border-yellow-400/50 shadow-2xl shadow-yellow-500/10 transition-all duration-500 hover:-translate-y-3 hover:border-yellow-300 hover:shadow-yellow-400/30 sm:w-72" data-testid={dup === 0 ? `testimoni-poster-${i + 1}` : undefined}>
                    <img src={src} alt={`${ms ? "Testimoni pelajar PMM" : "PMM student testimonial"} ${i + 1}`} className="h-auto w-full" loading="lazy" />
                  </div>
                )),
              )}
            </div>
          </div>

          {/* Video Testimoni */}
          <div className="mx-auto mt-16 max-w-7xl px-4 sm:px-6" data-testid="testimoni-videos">
            <div className="text-center">
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl">
                <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                  {ms ? "Video Feedback" : "Video Feedback"}
                </span>{" "}
                {ms ? "Ibu Bapa" : "From Parents"}
              </h3>
              <div className="mx-auto mt-3 h-1 w-28 rounded-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
            </div>
            <div className="mt-10 flex flex-wrap items-start justify-center gap-8">
              {[
                {
                  src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/bfuyj8jp_WhatsApp%20Video%202026-08-13%20at%2011.38.13%20AM.mp4",
                  ms: "Anak jadi rajin dan minat membaca",
                  en: "My child became diligent and loves reading",
                },
                {
                  src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/jey7y1ts_WhatsApp%20Video%202026-08-13%20at%2011.38.45%20AM.mp4",
                  ms: "Anak dah boleh buat karangan",
                  en: "My child can now write essays",
                },
                {
                  src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/dsqqtibc_WhatsApp%20Video%202026-08-13%20at%2011.40.09%20AM.mp4",
                  ms: "Anak lebih yakin berkomunikasi dan Darjah 1 dah boleh buat karangan",
                  en: "My child communicates confidently and writes essays in Year 1",
                },
              ].map((v, i) => (
                <div key={i} className={`pmm-pop ${i % 2 === 0 ? "pmm-float" : "pmm-float-delayed"} w-64 sm:w-72`} style={{ animationDelay: `${0.15 + i * 0.2}s` }} data-testid={`testimoni-video-${i + 1}`}>
                  <div className="pmm-cinematic relative overflow-hidden rounded-3xl border-2 border-yellow-400/60 bg-black shadow-2xl shadow-yellow-500/15 transition-all duration-500 hover:-translate-y-2 hover:border-yellow-300 hover:shadow-yellow-400/30">
                    <video src={`${v.src}#t=0.1`} controls preload="metadata" playsInline className="aspect-[9/16] w-full object-cover" />
                    <div className="pointer-events-none absolute left-3 top-3 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-widest text-blue-950 shadow-lg">
                      Feedback
                    </div>
                  </div>
                  <p className="mt-4 text-center font-display text-sm font-extrabold uppercase leading-snug text-white">
                    <Star className="mr-1 inline h-4 w-4 fill-yellow-400 text-yellow-400" />
                    {ms ? v.ms : v.en}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Testimoni WhatsApp Ibu Bapa */}
          <div className="mx-auto mt-16 max-w-7xl px-4 sm:px-6" data-testid="testimoni-whatsapp">
            <div className="text-center">
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl">
                <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#86efac,#22c55e)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                  {ms ? "Testimoni WhatsApp" : "WhatsApp Testimonials"}
                </span>{" "}
                {ms ? "Ibu Bapa" : "From Parents"}
              </h3>
              <div className="mx-auto mt-3 h-1 w-28 rounded-full bg-gradient-to-r from-transparent via-green-400 to-transparent" />
              <p className="mx-auto mt-4 max-w-xl text-sm text-blue-100">
                {ms
                  ? "Perkongsian ikhlas ibu bapa selepas anak mengikuti Kelas Program Membaca PMM."
                  : "Honest messages from parents after their children joined the PMM Reading Program."}
              </p>
            </div>
            <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {WHATSAPP_TESTIMONIALS.map((tst, i) => (
                <div
                  key={tst.name}
                  className={`pmm-pop ${i % 2 === 0 ? "pmm-float" : "pmm-float-delayed"} overflow-hidden rounded-3xl border-2 border-green-400/30 shadow-2xl shadow-green-500/10 transition-all duration-500 hover:-translate-y-2 hover:border-green-300/60 hover:shadow-green-400/25`}
                  style={{ animationDelay: `${0.1 + i * 0.12}s` }}
                  data-testid={`testimoni-whatsapp-${i + 1}`}
                >
                  {/* WhatsApp header */}
                  <div className="flex items-center gap-3 bg-[#075E54] px-4 py-3">
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#25D366] font-display text-sm font-extrabold text-white">
                      {tst.name.split(" ").pop().charAt(0)}
                    </span>
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-bold text-white">{tst.name}</span>
                      <span className="block truncate text-[11px] font-semibold text-green-200">{tst.loc}</span>
                    </span>
                    <MessageCircle className="ml-auto h-5 w-5 shrink-0 text-green-200" />
                  </div>
                  {/* Chat body */}
                  <div className="bg-[#ECE5DD] p-4">
                    <div className="relative max-w-[95%] rounded-2xl rounded-tl-sm bg-white px-4 py-3 shadow-md">
                      <p className="text-sm font-medium leading-relaxed text-slate-800">{ms ? tst.ms : tst.en}</p>
                      <span className="mt-1.5 flex items-center justify-end gap-1 text-[10px] font-semibold text-slate-400">
                        {tst.time}
                        <CheckCheck className="h-3.5 w-3.5 text-[#34B7F1]" />
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Anugerah Pelajar Cemerlang */}
          <div className="mx-auto mt-20 max-w-7xl px-4 sm:px-6" data-testid="testimoni-anugerah">
            <div className="text-center">
              <div className="pmm-float mx-auto grid h-16 w-16 place-items-center rounded-full bg-gradient-to-br from-yellow-300 to-orange-500 text-blue-950 shadow-2xl shadow-yellow-500/40">
                <Trophy className="h-8 w-8" />
              </div>
              <h3 className="mt-4 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">
                <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                  {ms ? "Anugerah Pelajar Cemerlang PMM" : "PMM Excellent Student Awards"}
                </span>
              </h3>
              <div className="mx-auto mt-3 inline-block -rotate-1 rounded-xl bg-orange-500 px-5 py-1.5 shadow-lg">
                <span className="font-display text-sm font-extrabold uppercase tracking-wide text-white sm:text-base">
                  {ms ? "Dapat Hadiah RM100 & Sijil PMM!" : "Wins RM100 Cash & PMM Certificate!"}
                </span>
              </div>
              <div className="mx-auto mt-4 h-1 w-28 rounded-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
            </div>
            <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {[
                "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/r88dxhwx_WhatsApp%20Image%202026-08-13%20at%2011.41.44%20AM.jpeg",
                "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/lle5dhf7_WhatsApp%20Image%202026-08-13%20at%2011.42.50%20AM.jpeg",
                "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/in88hwe5_WhatsApp%20Image%202026-08-13%20at%2011.43.41%20AM.jpeg",
              ].map((src, i) => (
                <div key={i} className={`pmm-pop ${i % 2 === 0 ? "pmm-float" : "pmm-float-delayed"} pmm-cinematic relative overflow-hidden rounded-3xl border-2 border-yellow-400/60 shadow-2xl shadow-yellow-500/15 transition-all duration-500 hover:-translate-y-3 hover:rotate-1 hover:border-yellow-300 hover:shadow-yellow-400/40 ${i === 1 ? "lg:-mt-4" : ""}`} style={{ animationDelay: `${0.15 + i * 0.18}s` }} data-testid={`anugerah-poster-${i + 1}`}>
                  <img src={src} alt={`${ms ? "Anugerah Pelajar Cemerlang PMM" : "PMM Excellent Student Award"} ${i + 1}`} className="h-auto w-full" loading="lazy" />
                </div>
              ))}
            </div>
          </div>

          {/* Bintang PMM - Hadiah RM100 & Sijil */}
          <div className="mt-16" data-testid="testimoni-bintang">
            <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
              <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-white sm:text-2xl">
                {ms ? "Hadiah " : "Gift of "}
                <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                  RM100 & {ms ? "Sijil PMM" : "PMM Certificate"}
                </span>{" "}
                {ms ? "Kepada Pelajar PMM Yang Layak" : "For Qualified PMM Students"}
              </h3>
              <p className="mt-2 text-xs font-semibold uppercase tracking-widest text-blue-300">{ms ? "(Terma & Syarat)" : "(Terms & Conditions)"}</p>
              <div className="mx-auto mt-3 h-1 w-28 rounded-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
            </div>
            <div className="mt-8 overflow-hidden">
              <div className="pmm-marquee-reverse gap-6 px-3">
                {[...Array(2)].flatMap((_, dup) =>
                  [
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/ifnvuwoo_WhatsApp%20Image%202026-08-13%20at%2011.46.21%20AM.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/sehoh6i3_WhatsApp%20Image%202026-08-13%20at%2011.46.21%20AM%20%281%29.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/eujmapkf_WhatsApp%20Image%202026-08-13%20at%2011.46.22%20AM.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/c42c1o6g_WhatsApp%20Image%202026-08-13%20at%2011.46.22%20AM%20%281%29.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/3yzcwww2_WhatsApp%20Image%202026-08-13%20at%2011.46.23%20AM.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/s5va13eg_WhatsApp%20Image%202026-08-13%20at%2011.46.23%20AM%20%281%29.jpeg",
                    "https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/jc5kn6vq_WhatsApp%20Image%202026-08-13%20at%2011.46.23%20AM%20%282%29.jpeg",
                  ].map((src, i) => (
                    <div key={`${dup}-${i}`} className="pmm-cinematic relative w-64 shrink-0 overflow-hidden rounded-3xl border-2 border-yellow-400/50 shadow-2xl shadow-yellow-500/10 transition-all duration-500 hover:-translate-y-3 hover:border-yellow-300 hover:shadow-yellow-400/30 sm:w-72" data-testid={dup === 0 ? `bintang-poster-${i + 1}` : undefined}>
                      <img src={src} alt={`${ms ? "Bintang PMM" : "PMM Star"} ${i + 1}`} className="h-auto w-full" loading="lazy" />
                    </div>
                  )),
                )}
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link to="/register">
              <Button size="lg" className="h-14 gap-2 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 px-10 font-display text-base font-extrabold uppercase tracking-wide text-blue-950 shadow-2xl shadow-yellow-500/30 transition-transform duration-300 hover:scale-105" data-testid="testimoni-cta">
                {ms ? "Anak Anda Seterusnya!" : "Your Child Is Next!"}
                <ArrowRight className="h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Video Info PMM */}
      <section className="relative overflow-hidden" data-testid="landing-tutor-section">
        <div className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-16 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          {/* Video Info PMM */}
          <div className="text-center" data-testid="tutor-info-video">
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">
              <span className="text-orange-500">{ms ? "Video Info" : "Info Video"}</span>{" "}
              <span className="text-blue-800">PMM</span>
            </h3>
            <div className="mx-auto mt-3 h-1 w-24 rounded-full bg-gradient-to-r from-transparent via-blue-700 to-transparent" />
            <div className="pmm-pop mx-auto mt-8 w-full max-w-sm" style={{ animationDelay: "0.2s" }}>
              <div className="pmm-cinematic relative overflow-hidden rounded-3xl border-2 border-blue-800/40 bg-black shadow-2xl shadow-blue-900/25 transition-all duration-500 hover:-translate-y-2 hover:border-orange-400 hover:shadow-orange-500/25">
                <video
                  src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/791lfi5d_WhatsApp%20Video%202026-08-13%20at%2011.50.30%20AM.mp4#t=0.1"
                  controls
                  preload="metadata"
                  playsInline
                  className="h-auto w-full"
                />
                <div className="pointer-events-none absolute left-3 top-3 rounded-full bg-gradient-to-r from-blue-800 to-blue-600 px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-widest text-white shadow-lg">
                  Info PMM
                </div>
              </div>
            </div>
            {/* Poster Kenapa Anak Perlu Join PMM */}
            <div className="pmm-pop mx-auto mt-8 w-full max-w-sm" style={{ animationDelay: "0.35s" }} data-testid="tutor-info-poster">
              <button
                type="button"
                onClick={() => setLightbox(INFO_JOIN_POSTER)}
                className="pmm-cinematic group block w-full overflow-hidden rounded-3xl border-2 border-blue-800/40 shadow-2xl shadow-blue-900/25 transition-all duration-500 hover:-translate-y-2 hover:border-orange-400 hover:shadow-orange-500/25"
              >
                <img
                  src={INFO_JOIN_POSTER}
                  alt={ms ? "Kenapa anak perlu join Program Membaca PMM" : "Why your child should join the PMM Reading Program"}
                  className="h-auto w-full transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Barisan Kepimpinan PMM (carta organisasi) */}
      <LeadershipChart ms={ms} setLightbox={setLightbox} managers={MANAGERS} sabahPoster={SABAH_MANAGER_POSTER} />

      {/* Buku Modul PMM */}
      <section className="border-y border-border/60 bg-muted/30" data-testid="landing-modulbuku-section">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-orange-500">{ms ? "Buku Modul" : "Module Books"}</span>{" "}
              <span className="text-blue-800">PMM</span>
            </h2>
            <p className="mt-3 font-semibold uppercase tracking-wide text-muted-foreground">
              {ms ? "Modul eksklusif 100% praktikal & berkesan — disusun mengikut tahap anak" : "Exclusive modules, 100% practical & effective — arranged by your child's level"}
            </p>
          </div>

          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            <div className="pmm-pop pmm-cinematic relative overflow-hidden rounded-3xl border-2 border-blue-800/30 shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl lg:col-span-2" style={{ animationDelay: "0.1s" }} data-testid="modulbuku-img-1">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/zlpv2xln_WhatsApp%20Image%202026-08-13%20at%2011.50.49%20AM.jpeg"
                alt={ms ? "Murid bersama Buku Modul PMM" : "Students with PMM Module Books"}
                className="h-full min-h-[280px] w-full object-cover"
                loading="lazy"
              />
              <div className="pointer-events-none absolute left-4 top-4 rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-widest text-white shadow-lg">
                {ms ? "100% Praktikal Berkesan!" : "100% Practical & Effective!"}
              </div>
            </div>
            <div className="pmm-pop pmm-float-delayed pmm-cinematic relative overflow-hidden rounded-3xl border-2 border-orange-400/40 shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl" style={{ animationDelay: "0.25s" }} data-testid="modulbuku-img-2">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/n4wcmwq7_WhatsApp%20Image%202026-08-13%20at%2011.51.37%20AM.jpeg"
                alt={ms ? "Anak mesti lancar membaca dengan PMM" : "Children must read fluently with PMM"}
                className="h-full min-h-[280px] w-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="mt-10 grid items-center gap-10 lg:grid-cols-2">
            <div className="pmm-pop pmm-float pmm-cinematic relative mx-auto w-full max-w-md overflow-hidden rounded-3xl border-2 border-blue-800/30 shadow-2xl transition-all duration-500 hover:rotate-1 hover:shadow-blue-900/30" style={{ animationDelay: "0.2s" }} data-testid="modulbuku-poster">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_89891435-6db1-403c-a368-9f416e4fb932/artifacts/uwmx112z_WhatsApp%20Image%202026-08-13%20at%2011.53.56%20AM.jpeg"
                alt={ms ? "Poster Program Membaca PMM" : "PMM Reading Program poster"}
                className="h-auto w-full"
                loading="lazy"
              />
            </div>
            <div>
              <ul className="space-y-3">
                {[
                  { ms: "Kaedah terbukti — berpengalaman sejak 2007", en: "Proven method — experienced since 2007" },
                  { ms: "Meningkatkan keyakinan & kefahaman", en: "Boosts confidence & understanding" },
                  { ms: "Membina tabiat membaca seawal usia", en: "Builds reading habits from an early age" },
                  { ms: "Buku modul disediakan dengan latihan praktikal", en: "Module books provided with practical exercises" },
                ].map((item, i) => (
                  <li key={i} className="pmm-pop group flex items-start gap-4 rounded-2xl border border-blue-100 bg-white px-5 py-3.5 shadow-sm transition-all duration-300 hover:translate-x-2 hover:border-orange-300 hover:shadow-lg" style={{ animationDelay: `${0.25 + i * 0.1}s` }}>
                    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-gradient-to-br from-blue-800 to-blue-600 text-white shadow-md transition-transform duration-300 group-hover:scale-110">
                      <CheckCircle2 className="h-5 w-5" />
                    </span>
                    <span className="pt-0.5 font-semibold text-blue-950">{ms ? item.ms : item.en}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <Link to="/register">
                  <Button size="lg" className="h-13 gap-2 rounded-full bg-orange-500 px-8 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-500/30 transition-transform duration-300 hover:scale-105 hover:bg-orange-600" data-testid="modulbuku-cta">
                    {ms ? "Bina Asas Anak Sekarang" : "Build Your Child's Foundation Now"}
                    <ArrowRight className="h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App features */}
      <section className="relative overflow-hidden" data-testid="landing-app-section">
        <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-10 h-72 w-72 rounded-full bg-blue-700/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
              <span className="text-blue-800">{ms ? "Satu Aplikasi" : "One App"}</span>{" "}
              <span className="text-orange-500">{ms ? "Untuk Semua" : "For Everything"}</span>
            </h2>
            <div className="mx-auto mt-4 h-1 w-32 rounded-full bg-gradient-to-r from-transparent via-orange-500 to-transparent" />
          </div>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {features.map((f, i) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  className={`pmm-pop ${i % 2 === 0 ? "pmm-float" : "pmm-float-delayed"} group rounded-[1.75rem] border-2 bg-white p-6 shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${i % 2 === 0 ? "border-orange-400/60 shadow-orange-500/10 hover:shadow-orange-500/25" : "border-blue-700/50 shadow-blue-800/10 hover:shadow-blue-800/25"}`}
                  style={{ animationDelay: `${0.1 + i * 0.12}s` }}
                  data-testid={`app-feature-${i + 1}`}
                >
                  <div className={`grid h-14 w-14 place-items-center rounded-2xl text-white shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6 ${i % 2 === 0 ? "bg-gradient-to-br from-orange-600 to-orange-400" : "bg-gradient-to-br from-blue-900 to-blue-600"}`}>
                    <Icon className="h-7 w-7" />
                  </div>
                  <h3 className={`mt-4 font-display text-lg font-extrabold uppercase tracking-tight ${i % 2 === 0 ? "text-orange-600" : "text-blue-800"}`}>{f.title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-blue-950/80">{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Proses Pendaftaran */}
      <ProsesPendaftaran ms={ms} adminWa={MANAGERS.fizikal.wa} />

      {/* CTA */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="pmm-cinematic relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 px-6 py-16 text-center shadow-2xl shadow-blue-900/30 sm:px-12" data-testid="landing-cta-banner">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-orange-500/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-yellow-400/20 blur-3xl" />
          <div className="relative">
            <div className="flex items-center justify-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="pmm-pop h-5 w-5 fill-yellow-400 text-yellow-400" style={{ animationDelay: `${i * 0.1}s` }} />
              ))}
            </div>
            <h2 className="mx-auto mt-4 max-w-3xl font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">
              {ms ? "Sedia Untuk Mulakan Perjalanan " : "Ready To Start Your Child's "}
              <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f2dd8e,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
                {ms ? "Membaca Anak Anda?" : "Reading Journey?"}
              </span>
            </h2>
            <p className="mx-auto mt-4 max-w-xl font-semibold text-blue-100">
              {c(
                "cta_text",
                "Daftar akaun ibu bapa secara percuma dan daftarkan anak anda hari ini.",
                "Create a free parent account and register your child today.",
              )}
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/register">
                <Button size="lg" className="pmm-atau h-14 gap-2 rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-10 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-2xl shadow-orange-500/40 transition-transform duration-300 hover:scale-105 sm:text-lg" data-testid="cta-banner-register">
                  {ms ? "Daftar Sekarang" : "Register Now"}
                  <ArrowRight className="h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative overflow-hidden bg-gradient-to-b from-blue-950 to-[#0d2566] text-white" data-testid="landing-footer">
        <div className="h-1 w-full bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />
        <div className="pointer-events-none absolute -left-24 top-0 h-64 w-64 rounded-full bg-orange-500/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-0 h-64 w-64 rounded-full bg-blue-500/10 blur-3xl" />
        <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src={PMM_LOGO} alt="Logo PMM" className="h-12 w-12 rounded-2xl border-2 border-yellow-400/50 object-cover shadow-lg" data-testid="landing-footer-logo" />
              <div className="leading-tight">
                <div className="font-display text-lg font-extrabold uppercase">Kelas Program Membaca PMM</div>
                <div className="text-xs font-semibold uppercase tracking-widest text-yellow-400">{ms ? "Mesti Lancar Baca" : "Must Read Fluently"}</div>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm font-medium text-blue-200">
              {ms
                ? "Membaca membina generasi cemerlang — sejak 2007, lebih 20,000+ pelajar lancar membaca."
                : "Reading builds an excellent generation — since 2007, over 20,000+ students read fluently."}
            </p>
            <div className="mt-4 flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-extrabold uppercase tracking-widest text-yellow-400">{ms ? "Hubungi Kami" : "Contact Us"}</h4>
            <ul className="mt-5 space-y-4 text-sm">
              {[
                { icon: Phone, text: cms.contact_phone || "016-7202689" },
                { icon: Mail, text: cms.contact_email || "admin@membacapmm.com" },
                { icon: MapPin, text: cms.contact_address || "Kuala Lumpur, Malaysia" },
              ].map((item, i) => (
                <li key={i} className="group flex items-center gap-3">
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white/10 text-yellow-400 transition-colors duration-300 group-hover:bg-orange-500 group-hover:text-white">
                    <item.icon className="h-4 w-4" />
                  </span>
                  <span className="font-semibold text-blue-100">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-extrabold uppercase tracking-widest text-yellow-400">{ms ? "Mula Sekarang" : "Get Started"}</h4>
            <p className="mt-5 text-sm font-medium text-blue-200">
              {ms ? "Daftar percuma dan mulakan perjalanan membaca anak anda hari ini." : "Register for free and start your child's reading journey today."}
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <Link to="/register">
                <Button className="rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-6 font-display text-sm font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-500/30 transition-transform duration-300 hover:scale-105" data-testid="footer-register-btn">
                  {ms ? "Daftar" : "Register"}
                </Button>
              </Link>
              <Link to="/login">
                <Button variant="outline" className="rounded-full border-2 border-yellow-400/60 bg-transparent px-6 font-display text-sm font-extrabold uppercase tracking-wide text-yellow-400 hover:bg-yellow-400 hover:text-blue-950" data-testid="footer-login-btn">
                  {ms ? "Log Masuk" : "Sign In"}
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <div className="relative border-t border-white/10">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs font-semibold uppercase tracking-wide text-blue-300 sm:px-6 md:flex-row">
            <span>© {new Date().getFullYear()} Kelas Program Membaca PMM — {ms ? "Hak cipta terpelihara" : "All rights reserved"}</span>
            <span className="text-yellow-400/80">{ms ? "PMM — Membaca Membina Generasi Cemerlang" : "PMM — Reading Builds An Excellent Generation"}</span>
          </div>
        </div>
      </footer>

      {/* Lightbox untuk galeri gambar */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-blue-950/90 p-4 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
          data-testid="landing-lightbox"
        >
          <button
            type="button"
            className="absolute right-4 top-4 grid h-11 w-11 place-items-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
            onClick={() => setLightbox(null)}
            aria-label={ms ? "Tutup" : "Close"}
            data-testid="lightbox-close-btn"
          >
            <X className="h-6 w-6" />
          </button>
          <img
            src={lightbox}
            alt={ms ? "Paparan penuh gambar PMM" : "PMM image full view"}
            className="max-h-[85vh] w-auto max-w-full rounded-2xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
